import { apiClient, apiClientWithToken } from '@/api/client'
import { endpoints } from '@/api/endpoints'
import { LoginRequest, LoginResponse, UserDetailsResponse } from '@/api/types'

/**
 * Authentication service for handling login and user details
 * Updated to properly handle token passing between API calls
 */
export class AuthService {
  /**
   * Authenticate user with email and password
   */
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await apiClient.post<LoginResponse>(
      endpoints.auth.login,
      credentials
    )
    return response.data
  }

  /**
   * Get user details by username using the provided token
   * This method uses a temporary token since the user isn't fully authenticated yet
   */
  async getUserDetails(username: string, token: string): Promise<UserDetailsResponse> {
    console.log(`👤 Fetching user details for: ${username} with token`)
    
    const apiWithToken = apiClientWithToken(token)
    const response = await apiWithToken.get(endpoints.auth.userDetails(username))
    return response.data as UserDetailsResponse
  }

  /**
   * Get user details using stored token (for already authenticated users)
   */
  async getCurrentUserDetails(username: string): Promise<UserDetailsResponse> {
    const response = await apiClient.get<UserDetailsResponse>(
      endpoints.auth.userDetails(username)
    )
    return response.data
  }

  /**
   * Logout current user (clear local state)
   */
  async logout(): Promise<void> {
    // For now, just clear local state
    // Add server-side logout call if needed
    return Promise.resolve()
  }
}

// Export singleton instance
export const authService = new AuthService()
